export default __webpack_public_path__ + "static/media/TECH_INSIDE_MIDDLE_PNG.d937a97e.png";